import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { WithChildren } from '@/lib/types';

import * as S from './Checkbox.styles';

export type CheckboxSize = 's' | 'm' | 'l';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    WithChildren<false> {
  checked?: boolean;
  hasError?: boolean;
  isFluid?: boolean;
  name?: string;
  size?: CheckboxSize;
}

export const Checkbox = forwardRef(
  (
    {
      checked,
      children,
      disabled = false,
      hasError,
      isFluid = false,
      name,
      onChange,
      size = 'm',
      ...inputProps
    }: CheckboxProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    return (
      <S.Wrapper
        data-testid='CheckboxWrapper'
        disabled={disabled}
        forwardedAs='label'
        isFluid={isFluid}
        scale='p2'
        size={size}
      >
        <S.Input
          ref={ref}
          checked={checked}
          data-testid='CheckboxInput'
          disabled={disabled}
          hasError={hasError}
          name={name}
          onChange={onChange}
          type='checkbox'
          {...inputProps}
        />
        {children}
      </S.Wrapper>
    );
  },
);

export const defaultCheckboxProps: Required<Pick<CheckboxProps, 'size'>> = {
  size: 'm',
};

Checkbox.defaultProps = defaultCheckboxProps;

Checkbox.displayName = 'Checkbox';
